import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {WORD_DETAIL_API_URL} from '../../defines/protocol';
import {Word} from '../../models/word.model';
import {ApiService} from '../api/api.service';
import {WordService} from './word.service';

@Injectable()
export class SajaseungeoWordService extends WordService {
  constructor(
    protected override api: ApiService,
  ) {
    super(api);
  }

  public override GetDetail(word_id: string): Observable<Word> {
    const url = WORD_DETAIL_API_URL + word_id + '/?saja=1';
    console.log('SajaseungeoWordService::GetDetail() url =', url);

    return this.api.Get(url).pipe(
      map(value => {
        const out = new Word(value);
        console.log('SajaseungeoWordService::GetDetail data = ', value, out);
        return out;
      }),
    );
  }
}
